/// Ce script est également appelé
/// sur les pages /EspaceClient/account/*

class Connexion extends Inscription {
	/// Il s'agit de la fonction appelée sur chacune des pages du tunnel
	initialize() {
		let self = this;
		let objSelectors = {
			btnConnexionCompte: document.getElementById('goToCoordonnees'),
			btnCreationCompte: document.getElementById('goToCreationCompte'),
			inputEmailCompte: document.getElementById('email'),
			inputPwdCompte: document.getElementById('password')
		}

		const formulaire = new Formulaire(config.form);

		/// on conditionne le lancement des fonctions spécifiques au tunnel
		if (this.config.path === 'tunnel') {
			/// On lance les fonctions génériques liées à la class Inscription
			super.initialize();

			formulaire.initialize('RegisterForm');
			formulaire.initialize('LogOnForm');

			document.getElementById('goToCoordonnees').addEventListener('click', function (e) {

				//if (document.getElementById('LogOnForm').checkValidity()) {
				e.preventDefault();
				self.LogOn();
				//}
			})

			document.getElementById('goToCreationCompte').addEventListener('click', function (e) {
				document.getElementById('EmailCreation').required = true;

				//if (document.getElementById('EmailCreation').validity.valid) {
				e.preventDefault();
				self.GoToRegister();
				//}

			})

			self.toggleSection('connexionLogin');

			//document.addEventListener('DOMContentLoaded', function () {

			//	self.signin();
			//});


			document.getElementById('lienConnectezvous').addEventListener('click', function (e) {
				document.querySelector('#EmailCreation + .field-validation-error').style.display = 'none';

				let elCreation = document.getElementById('connexionCreation');
				elCreation.classList.remove('is-error');

			})

			document.getElementById('lienCreerUnCompte').addEventListener('click', function (e) {
				document.querySelector('#email + .field-validation-error').style.display = 'none';
				document.querySelector('#password + .field-validation-error').style.display = 'none';

				let elConnexion = document.getElementById('connexionLogin');
				elConnexion.querySelectorAll('.field').forEach(el => el.classList.remove('is-error'));

			})

		} else if (this.config.path === 'espaceClient/account') {
			if (this.config.page === 'logon') {
				formulaire.initialize('LogOnConnecForm');

				objSelectors.btnConnexionCompte = document.getElementById('btnseconnecterec');

				let fieldsError = document.querySelectorAll('.field-validation-error');
				fieldsError.forEach(el => {
					if (el.innerText !== '') {
						el.parentElement.classList.add('form-field--is-error')
					}
				});
			}
		}

		/// cas du remplissage des champs avec des identifiants enregistrés
		/// champ creation compte dans tunnel
		window.addEventListener('selectionchange', event => {
			if (event.target.id === 'password') {
				if (document.querySelector('#password + .field-validation-error') !== null) {
					document.querySelector('#password + .field-validation-error').style.display = 'none';
				}

			}
		})
	}

	toggleSection(idHide) {
		let blockHide = document.getElementById(idHide);

		document.querySelectorAll('.account--link button').forEach(el => {
			el.addEventListener('click', function (e) {
				let toShow = document.getElementById(e.target.dataset.toggleSectionToShow),
					toHide = document.getElementById(e.target.dataset.toggleSectionToHide);
				helpers.hide(toHide);
				helpers.show(toShow);

				/// On change le type des buttons
				// blockHide.querySelector('[data-form-submit]').type = 'button';
				// toShow.querySelector('[data-form-submit]').type = 'submit';
			})
		})
	}

	GoToRegister() {

		//var token = $('[name=__RequestVerificationToken]').val();
		//var headers = {};
		//headers["__RequestVerificationToken"] = token;

		$.ajax({
			url: config.url.GoToRegister,
			async: false,
			type: 'POST',
			//headers: headers,
			data: $('#RegisterForm').serialize(),
			success: function (data) {

				switch (data) {
				case 1:
					window.location.href = config.url.creation;
					break;

				case 0:
					var url = config.url.connexion;

					if (url.includes("/inscription/connexion")) {
						window.location.href = url;
					}
					break;
				default:

					$("#connexion").html(data);
					let elCreation = document.getElementById('connexionCreation'),
						elConnexion = document.getElementById('connexionLogin');

					helpers.hide(elConnexion);
					helpers.show(elCreation);

					tunnelApp.initialize();
				}
			}
		});
	}

	LogOn() {

		//var token = $('[name=__RequestVerificationToken]').val();
		//var headers = {};
		//headers["__RequestVerificationToken"] = token;

		$.ajax({
			url: config.url.LogOn,
			async: false,
			type: 'POST',
			//headers: headers,
			data: $('#LogOnForm').serialize(),
			success: function (data) {

				switch (data) {
				case 1:
					window.location.href = config.url.coord;
					break;

				case 0:
					var url = config.url.connexion;

					if (url.includes("/inscription/connexion")) {
						window.location.href = url;
					}
					break;
				default:

					$("#connexion").html(data);
					let elCreation = document.getElementById('connexionCreation'),
						elConnexion = document.getElementById('connexionLogin');

					helpers.hide(elCreation);
					helpers.show(elConnexion);

					new app(); // password
					tunnelApp.initialize();
				}
			}
		});
	}

	signin() {
		let self = this;
		let btnCreationCompte = document.getElementById('goToCreationCompte');
		let inputCreationCompte = document.getElementById('EmailCreation');
		let isInit = true; /// pour ne pas mettre le champ en erreur au load de la page

		/// On gère le focusIn et le focusOut
		self._events(inputCreationCompte, btnCreationCompte, isInit, 'RegisterForm');

	}

	/// @Event
	/// Gestion des focus des champs emails et password
	_events(input, btn, isInit, formElement) {
		let self = this;
		const regexMail = /^[a-zA-Z0-9._-]+@[a-z0-9._-]{2,}\.[a-z]{2,4}$/;
		const utilities = new utilitiesInscription(config);
		utilities._getDataForm(formElement);


		///	On met à jour le btn de validation et les champs d'erreur
		let eventsList = ['focusin', 'input', 'keyup'];
		for (let event of eventsList) {
			input.addEventListener(event, (event) => {
				event.target.closest('.field').classList.remove('form-field--is-error');
				if (event.target.nextElementSibling != null) {
					event.target.nextElementSibling.innerHTML = '';
				}
			});
		}
	}

	/// @Boolean
	/// Teste si le champ est correctement rempli et renvoie true|false
	_isValid(input, isInit) {
		let value = input.value;
		if (!isInit) {
			if (input.type === 'email') {
				if (this.config.utilities.testRegex(this.config.utilities.regexMail, value)) {
					return true;
				} else {
					let msg = 'Votre email est incorrect';
					input.closest('.field').classList.add('form-field--is-error');
					if (input.nextElementSibling != null) {
						input.nextElementSibling.innerHTML = msg;
					}
					return false;
				}
			} else if (value === '') {
				let msg = 'Ce champ ne peut pas être vide';
				input.closest('.field').classList.add('form-field--is-error');
				if (input.nextElementSibling != null) {
					input.nextElementSibling.innerHTML = msg;
				}
				return false;
			}
		} else {
			return false;
		}
	}
}